import React from "react";
import {
  GET_VISIBILITY,
  desiredOrderCVESeverity,
  cveBySeverityMap,
  FETCH_CVE_BY_SEVERITIES,
} from "./NetSpaceConstant";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import { Box, Grid, useMediaQuery } from "material-ui-core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { StyledCardHeader } from "./NetSpaceUtils";
import { sensitivityColor } from "./NetSpaceUtils";
import { PieChart, Pie, Tooltip, Cell } from "recharts";
import { CustomCard } from "./NetSpaceCommonComp";

function CveBySeverity() {
  const isSmall = useMediaQuery("(max-width:1600px)");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: FETCH_CVE_BY_SEVERITIES,
    });
  }, []);
  const cveBySeverity = useSelector(
    (state) => state.NetspaceReducer.cveBySeverity,
  );
  const loader = useSelector(
    (state) => state.NetspaceReducer.componentLoader[FETCH_CVE_BY_SEVERITIES],
  );
  const totalHosts = cveBySeverity
    ? Object.values(cveBySeverity).reduce((acc, curr) => acc + curr, 0)
    : 0;
  const renderContent = () => {
    if (cveBySeverity) {
      let renderEachMonitor = [];
      let pieData = [];
      desiredOrderCVESeverity.forEach((monitor) => {
        if (monitor in cveBySeverity) {
          renderEachMonitor.push(
            <>
              <Grid item xs={12}>
                <div className={monitor}>
                  {cveBySeverity[monitor]} {cveBySeverityMap[monitor]}
                </div>
              </Grid>
            </>
          );
          pieData.push({
            name: monitor,
            value: cveBySeverity[monitor],
            color: sensitivityColor(monitor),
          });
        } else {
          renderEachMonitor.push(
            <>
              <Grid item xs={12}>
                <div className={monitor}>0 {cveBySeverityMap[monitor]}</div>
              </Grid>
            </>
          );
          pieData.push({
            name: monitor,
            value: 0,
            fill: sensitivityColor(monitor),
          });
        }
      });

      if (renderEachMonitor.length === 0) {
        return <div>No Data Available</div>;
      }

      return (
        <a
          className="a-tag-none"
          href="https://nodezero.druvstar.net/investigate/hosts"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Grid container direction="row" spacing={2}>
            <div className="netspace-common-container-class">
              <div className="netspace-value-container cveSeverity">
                {renderEachMonitor.map((item, i) => (
                  <React.Fragment key={i}>{item}</React.Fragment>
                ))}
              </div>
              <Grid item xs={6}>
                <Box
                  sx={{
                    width: isSmall ? 120 : 150,
                    height: isSmall ? 100 : 120,
                  }}
                >
                  <PieChart
                    className="netspace-card-pie"
                    width={isSmall ? 130 : 150}
                    height={isSmall ? 100 : 120}
                  >
                    <Pie
                      isAnimationActive={false}
                      data={pieData}
                      nameKey="name"
                      dataKey="value"
                    >
                      {pieData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry["color"]} />
                      ))}
                    </Pie>
                    <Tooltip wrapperClassName="custom-tooltip" />
                  </PieChart>
                </Box>
              </Grid>
            </div>
          </Grid>
        </a>
      );
    }

    return <div>No Data Available</div>;
  };
  return (
    <>
      <Grid item xs={2}>
        <CustomCard color="white">
          <StyledCardHeader
            title={`Vulnerability by Severity: ${totalHosts}`}
          />
          <CardContent className="card-content">
            {loader ? (
              <img src={Page_Loader} alt="loading" className="loader-img"></img>
            ) : (
              renderContent()
            )}
          </CardContent>
        </CustomCard>
      </Grid>
    </>
  );
}

export default CveBySeverity;
